const { connect } = require('react-redux');
const { context } = require('app-context');
const WelcomePageManagement = require('../components/WelcomePageManagement');

const selectors = context.selectors.all;
const actions = context.actions;

module.exports = connect(
    (state) => ({
        status: selectors.getWelcomePageManagementStatus(state),
        settings: selectors.getWelcomePageManagementSettings(state)
    }),
    {
        fetchSettings: actions.welcomePageManagement.fetchSettings,
        updateSchoolText: actions.welcomePageManagement.updateSchoolText,
        updateRoleText: actions.welcomePageManagement.updateRoleText
    }
)(WelcomePageManagement);
